import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import LayerDropdown from './LayerDropdown'
import LayerText from './LayerText'

const LayerError = ({
    active,
    exploreLayers,
    screenLayers,
    layers,
    index,
    removeLayer,
    layer,
    errorLayers,
    setErrorLayers
}) => {
    const [selected, setSelected] = useState('None')
    const [message, setMessage] = useState('')

    return (
        <div className="error-layer">
            <div className="field">
                <LayerDropdown
                    categories={active === 'explore' ? exploreLayers : screenLayers}
                    layers={layers}
                    index={index}
                    removeLayer={removeLayer}
                    lyr={layer}
                    errorLayers={errorLayers}
                    setErrorLayers={setErrorLayers}
                    setSelected={setSelected}
                    active={active}
                />
                <LayerText
                    index={index}
                    lyr={layer}
                    errorLayers={errorLayers}
                    setErrorLayers={setErrorLayers}
                    setMessage={setMessage}
                />
            </div>
        </div>
    )
}

LayerError.propTypes = {
    active: PropTypes.string.isRequired,
    exploreLayers: PropTypes.array,
    screenLayers: PropTypes.array,
    layers: PropTypes.array,
    setErrorLayers: PropTypes.func,
    errorLayers: PropTypes.array,
    index: PropTypes.number,
    removeLayer: PropTypes.func,
    layer: PropTypes.object,
    errorLayers: PropTypes.array
}

export default LayerError
